/**
 * @typedef {import('../index').SystemState} SystemState
 */

/**
 * @type {SystemState}
 */
export const initialSystemState = {
  error: {
    error: null,
    storeKey: null,
    action: null,
  },
  permission: {
    permission: null,
  },
  project: {
    permission: null,
    fileURL: null,
    userNameSearchResults: [],
    fileLoaded: false,
    isLoading: false,
    isOffline: false,
    resuming: false,
    checkingOfflineDrift: false,
    overwritingCloudWithBackup: false,
    showResumeMessageDialog: false,
    backingUpOfflineFile: false,
    unsavedChanges: false,
    conflictResolution: null,
    bootedOfflineFileWhilstOnline: false,
    projectNamingModalIsVisible: false,
    template: null,
    defaultName: null,
  },
  client: {
    userId: null,
    clientId: null,
    emailAddress: null,
    hasOnboarded: null,
    isOnWeb: null,
    isLoggedIn: false,
    dataClientIds: {},
    legacy__currentAppState: null,
  },
  license: {
    trialInfo: null,
    plottrLicense: null,
    proLicense: null,
    licenseCheckInterval: null,
    couldNotContactLicenseServer: false,
    isProduction: true,
  },
  account: {
    subscriptions: {
      proSubscription: null,
      plottrSubscription: null,
    },
  },
  knownFiles: [],
  templates: {
    templates: {},
    customTemplates: [],
  },
  settings: {
    exportSettings: null,
    appSettings: null,
    userSettings: null,
  },
  backups: {
    folders: [],
  },
  applicationState: {
    project: {
      loadingPlottrFileList: false,
      loadingProFileList: false,
      fileListLoaded: false,
      importingNewProject: false,
      isImportingAProject: false,
    },
    file: {
      fileURLToBoot: null,
      filePathToUpload: null,
      checkingFileToLoad: false,
      checkedFileToLoad: false,
      creatingCloudFile: false,
      uploadingFileToCloud: false,
      loadingFile: false,
      fileLoaded: false,
      renamingFile: false,
      deletingFile: false,
      savingFileAs: false,
      pathToProjectDuringBoot: null,
      noFileToShow: false,
      errorLoadingFile: false,
      errorIsUpdateError: false,
    },
    session: {
      loggingIn: false,
      checkingSession: false,
      sessionChecked: false,
      loggedIn: null,
    },
    license: {
      loadingTrial: false,
      trialLoaded: false,
      loadingLicense: false,
      licenseLoaded: false,
      fetchingLicense: false,
      fetchedLicense: false,
      checkingProSubscription: false,
      proSubscriptionChecked: false,
      fetchingProSubscription: false,
      fetchedProSubscription: false,
      hasActiveProSubscription: null,
      needsToCheckProSubscription: null,
      hasActivePlottrSubscription: null,
      needsToCheckPlottrSubscription: null,
      hasActiveTrial: null,
    },
    settings: {
      loadingSettings: false,
      settingsLoaded: false,
      loadingExportConfig: false,
      exportConfigLoaded: false,
    },
    proOnboarding: {
      isOnboarding: false,
      isOnboardingFromRoot: false,
      onboardingStep: null,
      forceLicenseCheck: false,
    },
    settingsWizard: {
      isInSettingsWizard: false,
      wizardStep: null,
      stagedLanguage: null,
    },
    update: {
      requestedCheck: false,
      shouldCheck: false,
      checking: false,
      available: false,
      percentDownloaded: 0,
      downloadInProgress: false,
      error: null,
      info: null,
      notifierHidden: false,
    },
    work: {
      busy: false,
    },
    userInteractions: {
      jumpCounter: 0,
      editState: 'VIEWING',
    },
    dashboard: {
      openTo: null,
      closed: false,
    },
    booting: {
      firstTimeBooting: false,
      receivedWindowState: false,
      percentageBooted: 0,
      descriptionOfBootingPhase: 'Initialising',
    },
    shutdown: {
      isQuitting: false,
    },
    network: {
      isOnline: null,
    },
    displayState: 'LOADING',
    featureSet: {
      mode: null,
      offlineModeEnabled: null,
    },
    isProduction: true,
  },
  imageCache: {},
  audioCache: {},
  notifications: {
    message: null,
    timeout: null,
    toast: {
      cardAction: null,
      newBookId: null,
      visible: false,
      lineAction: null,
    },
  },
  domEvents: {
    lastClick: {
      x: null,
      y: null,
      counter: 0,
    },
    droppedBeat: {
      coord: null,
      id: null,
    },
  },
  testingAndDiagnosis: {
    testingAndDiagnosisEnabled: false,
    v2: false,
  },
  undo: {
    history: [],
    future: [],
    generation: 0,
    recentlyUndidOrRedid: false,
    showUndoRedo: false,
    changeId: 0,
  },
  offline: {
    offlineFiles: [],
    createdOfflineFiles: [],
  },
  ideas: {
    ideas: [],
    threads: [],
    ideaToDisplay: null,
  },
}
